import React, { SyntheticEvent } from 'react';
import styles from './ChatCreation.scss';
import { InjectedTranslateProps, translate } from 'react-i18next';
import socialServerApi from '../../services/socialServerApi';
import { AVATARS } from '../../constants/avatars';
import _get from 'lodash/get';
import { MemberList } from './MemberList/MemberList';
import { SearchBox } from '../SearchBox/SearchBox';
import {
  withMemberSearch,
  WithMemberSearchInjectedProps,
} from '../../hoc/withMemberSearch/withMemberSearch';
import { Loader } from '../Loader/Loader';
import { NoInitialMembers } from './NoInitialMembers/NoInitialMembers';
import { NoMembersFound } from './NoMembersFound/NoMembersFound';
import { connect } from 'react-redux';
import {
  headerFontFamily,
  headerTextColorOrDefault,
  isExperimentOn,
  messagesFontFamily,
  primaryColorOrDefault,
} from '../../reducers';
import { Experiments } from '../../constants/experiments';
import Button from '../Button/Button';
import SelectedMembersList from './SelectedMembersList/SelectedMembersList';
import CreateGroupEntry from './CreateGroupEntry/CreateGroupEntry';
import AvatarPlaceHolder from '../../icons/dist/components/avatarPlaceHolder';
import { mediaManager } from '@wix/inbox-common';
import serverApi from '../../services/serverApi';
import { NO_HEADER } from '../Widgets/SocialChat/SocialChat';
import * as biLogger from '../../services/biLogger';

export interface SiteMember {
  userId: string;
  name: string;
  image?: {
    url?: string;
  };
}

interface OnCreateParam {
  id: string;
  name: string;
  avatar: any;
  userId: string;
  participantCount?: number;
}

interface ChatCreationProps
  extends InjectedTranslateProps,
    WithMemberSearchInjectedProps {
  onCreate(OnCreateParam): any;
  onCreateGroupChat?: any;
  onChangeHeader?: any;
  messageFont: string;
  headerFont: string;
  primaryColor: string;
  headerTextColor: string;
}

interface ChatCreationState {
  selectedMembers: SiteMember[];
  chatroomName: string;
  oneOnOneCreateChat: boolean;
  updateChatroomDetailStep: boolean;
  chatroomImage: string;
  presentImageLoader: boolean;
}

interface ChatCreationState {}

class ChatCreation extends React.Component<
  ChatCreationProps,
  ChatCreationState
> {
  constructor(props: ChatCreationProps) {
    super(props);

    this.state = {
      selectedMembers: [],
      oneOnOneCreateChat: true,
      chatroomName: '',
      updateChatroomDetailStep: false,
      chatroomImage: '',
      presentImageLoader: false,
    };
  }

  handleSelectedMemberListClicked = async (userId) => {
    biLogger.groupChatCreateMemberPickerRemove(userId);
    return this.handleSelect(userId);
  };

  handleMemberListClicked = async (userId) => {
    biLogger.groupChatCreateMemberPickerSelect(
      userId,
      this.state.selectedMembers.length,
    );
    return this.handleSelect(userId);
  };

  handleSelect = async (userId) => {
    if (this.state.oneOnOneCreateChat) {
      return this.oneOnOneHandleSelect(userId);
    }

    try {
      const userIdAlreadySelected: boolean = !!this.state.selectedMembers.find(
        (member) => member.userId === userId,
      );
      const selectedMember: SiteMember | undefined = this.props.members.find(
        (member) => member.userId === userId,
      );

      let newNumberOfElement = this.state.selectedMembers.length;
      if (!userIdAlreadySelected) {
        if (selectedMember) {
          this.setState({
            selectedMembers: this.state.selectedMembers.concat(selectedMember),
          });
          newNumberOfElement++;
        }
      } else {
        this.setState({
          selectedMembers: this.state.selectedMembers.filter(
            (member) => member.userId !== userId,
          ),
        });
        newNumberOfElement--;
      }
      if (this.props.onChangeHeader) {
        this.props.onChangeHeader(newNumberOfElement);
      }
    } catch (e) {
      console.error('ChatCreation handleSelect-', e);
    }
  };

  oneOnOneHandleSelect = async (userId) => {
    try {
      const {
        chatroomId: id,
        chatroom,
      } = await socialServerApi.createPrivateChatRoom(userId);

      const imgUrl = _get(chatroom, 'displayData.image.url');
      const name = _get(chatroom, 'displayData.name');

      const avatar = imgUrl
        ? { ...AVATARS.IMG.prop, imgUrl }
        : AVATARS.NONE.prop;

      this.props.onCreate({ id, name, avatar, userId });
    } catch (e) {}
  };

  handleNewGroupChatClicked = () => {
    this.setState({ oneOnOneCreateChat: false });
    biLogger.groupChatCreateStart();
    if (this.props.onCreateGroupChat) {
      this.props.onCreateGroupChat();
    }
  };

  handleNextStep = async () => {
    this.setState({ updateChatroomDetailStep: true });
    biLogger.groupChatCreateMemberPickerNext(this.state.selectedMembers.length);
    if (this.props.onChangeHeader) {
      this.props.onChangeHeader(NO_HEADER);
    }
  };

  handleCreateNewGroupChat = async () => {
    try {
      biLogger.groupChatCreateRoomInfoCreate(this.state.selectedMembers.length);

      const usersId = this.state.selectedMembers.map((item) => {
        return { userId: item.userId };
      });

      const groupChatroomName = this.state.chatroomName;
      const groupChatroomImage = { url: this.state.chatroomImage };
      const {
        chatroomId: id,
        chatroom,
      } = await socialServerApi.createGroupChatRoom(
        usersId,
        groupChatroomName,
        groupChatroomImage,
      );

      const imgUrl = _get(chatroom, 'displayData.image.url');
      const name = _get(chatroom, 'displayData.name');

      const avatar = imgUrl
        ? { ...AVATARS.IMG.prop, imgUrl }
        : AVATARS.NONE.prop;

      this.props.onCreate({
        id,
        name,
        avatar,
        userId: null,
        participantCount: usersId.length,
      });
    } catch (e) {
      console.error(e);
    }
  };

  renderListMember = () => {
    const {
      t,
      members,
      onMemberSearch,
      onFetchMore,
      searchTerm,
      messageFont,
      primaryColor,
    } = this.props;

    const hasMembers = members.length > 0;
    const hasSelectedMembers = this.state.selectedMembers.length > 0;
    const isPrivateChat = this.state.oneOnOneCreateChat;
    const isGroupChat = !isPrivateChat;

    return (
      <div
        className={styles.chatCreation}
        data-hook="chat-creation-wrapper"
        style={{ fontFamily: messageFont }}
      >
        {(hasMembers || searchTerm) && (
          <SearchBox
            onChange={onMemberSearch}
            placeholder={t('social.new-chat.search-placeholder')}
          />
        )}
        {hasSelectedMembers && (
          <SelectedMembersList
            numberOfMemberToScroll={6}
            numberOfMemberToPresent={6}
            selectedMembers={this.state.selectedMembers}
            onClickOnMember={this.handleSelectedMemberListClicked}
          />
        )}
        <div className={styles.memberList}>
          {isPrivateChat && (
            <CreateGroupEntry
              onCreateGroupClicked={this.handleNewGroupChatClicked}
              title={t('social.group-chat.start-message')}
            />
          )}
          {hasMembers ? (
            <MemberList
              members={members}
              onSelect={this.handleMemberListClicked}
              onFetchMore={onFetchMore}
              isMemberListForPrivateChat={
                !isGroupChat || (isGroupChat && !hasSelectedMembers)
              }
              entrySuffix={(id: string) => {
                if (!isGroupChat) {
                  return;
                }

                const isSelected = !!this.state.selectedMembers.find(
                  (member) => member.userId === id,
                );

                return (
                  <div
                    className={styles.checkbox}
                    data-hook="group-chat-check-box"
                  >
                    {isSelected ? (
                      <CheckboxCheck
                        size="20px"
                        data-hook="group-chat-check-box-check"
                        primarycolor={primaryColor}
                      />
                    ) : (
                      <CheckboxUncheck
                        size="20px"
                        data-hook="group-chat-check-box-uncheck"
                        primarycolor={primaryColor}
                      />
                    )}
                  </div>
                );
              }}
            />
          ) : searchTerm ? (
            <NoMembersFound searchTerm={searchTerm} />
          ) : (
            <NoInitialMembers />
          )}
        </div>
        {isGroupChat && hasSelectedMembers && (
          <div
            className={styles.nextChat}
            style={{ fontFamily: this.props.headerFont }}
          >
            <Button dataHook="next-button" onClick={this.handleNextStep}>
              {t('social.group-chat.next-button')}
            </Button>
          </div>
        )}
      </div>
    );
  };

  renderLoader = () => {
    return (
      <div className={styles.loaderWrapper}>
        <Loader />
      </div>
    );
  };

  handleFileSelect = async (e: SyntheticEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    const file = target.files && target.files[0];

    this.setState({ presentImageLoader: true });

    const { token, url, folderId } = await serverApi.getUploadToken();

    biLogger.groupChatCreateRoomInfoUploadAvatar();
    const returnFromMedia = await mediaManager.uploadFileToMedia({
      file,
      token,
      uploadUrlApi: url,
      folderId,
    });
    this.setState({
      chatroomImage: returnFromMedia.url,
      presentImageLoader: false,
    });
  };

  renderAddChatroomDetail = () => {
    const { t, primaryColor, headerTextColor, headerFont } = this.props;
    const { chatroomImage, chatroomName, presentImageLoader } = this.state;
    const mySelf = 1;
    const numberOfMembers = this.state.selectedMembers.length + mySelf;
    const colorWhite = '#FFFFFF';
    const colorWhiteWithOpacity = `rgba(255, 255, 255, 0.2)`;

    return (
      <div
        className={styles.addGroupChatroomDetail}
        data-hook="update-group-chatroom-wrapper"
      >
        <div
          className={styles.chatroonHeader}
          style={{ backgroundColor: primaryColor }}
        >
          <div className={styles.chatroomImageAboveSpace}></div>
          <div className={styles.chatroomImage}>
            {presentImageLoader ? (
              <div
                id="container"
                data-hook="group-chatroom-image-loader"
                className={styles.chatroomImageLoader}
                style={{ backgroundColor: colorWhiteWithOpacity }}
              >
                <div className={styles.chatroomLoader}>
                  <Loader dimensions={24} borderWidth={3} color={colorWhite} />
                </div>
              </div>
            ) : chatroomImage ? (
              <img
                data-hook="group-chatroom-image"
                className={styles.chatroomImagePic}
                alt="group chat image"
                src={chatroomImage}
              />
            ) : (
              <AvatarPlaceHolder
                size="60px"
                style={{ color: headerTextColor }}
                className={styles.chatroomImageIcon}
                data-hook={'group-chatroom-image-placeholder'}
              />
            )}
            <input
              type={'file'}
              accept={'image/*,.png,.jpg,.bpm'}
              className={styles.chatroomImageButton}
              data-hook="group-chatroom-image-button"
              onChange={this.handleFileSelect}
            />
          </div>
          <div
            className={styles.chatroomNameDiv}
            style={{ fontFamily: headerFont }}
          >
            <input
              className={styles.chatroomName}
              data-hook="group-chatroom-name"
              type="text"
              onChange={(event) =>
                this.setState({ chatroomName: event.target.value })
              }
              placeholder={t('social.group-chat.name-placeholder')}
              style={{ color: headerTextColor }}
              value={chatroomName}
            />
          </div>
          <div
            className={styles.chatroomSeperator}
            style={{ backgroundColor: headerTextColor }}
          ></div>
          <div className={styles.chatroomNameBelowSpace}></div>
          <div
            className={styles.memberSelected}
            data-hook="group-chatroom-number-members"
            style={{ color: headerTextColor, fontFamily: headerFont }}
          >
            {t('social.group-chat.number-members', { number: numberOfMembers })}
          </div>
        </div>
        <div className={styles.newChat} style={{ fontFamily: headerFont }}>
          <Button
            dataHook="create-group-chat-button"
            onClick={this.handleCreateNewGroupChat}
            disabled={this.state.chatroomName.length <= 0}
          >
            {t('social.create-chat-button')}
          </Button>
        </div>
      </div>
    );
  };

  render() {
    if (this.props.loadingMembers) {
      return this.renderLoader();
    }
    if (this.state.updateChatroomDetailStep) {
      return this.renderAddChatroomDetail();
    }
    return this.renderListMember();
  }
}

const mapStateToProps = (state) => ({
  messageFont: messagesFontFamily(state),
  headerFont: headerFontFamily(state),
  primaryColor: primaryColorOrDefault(state),
  headerTextColor: headerTextColorOrDefault(state),
});

export default translate()(
  withMemberSearch(connect(mapStateToProps)(ChatCreation)),
);

interface CheckboxCheckProps extends React.SVGAttributes<SVGElement> {
  size?: string;
  primarycolor: string;
}
export const CheckboxCheck: React.FunctionComponent<CheckboxCheckProps> = ({
  size,
  ...props
}) => (
  <svg
    viewBox="0 0 20 20"
    fill={props.primarycolor}
    width={size || '20'}
    height={size || '20'}
    {...props}
  >
    <g
      id="SOCIAL-CHAT"
      stroke="none"
      fill="none"
      strokeWidth="1"
      fillRule="evenodd"
    >
      <g id="ICONS" transform="translate(-242 -36)">
        <g id="check" transform="translate(242 36)">
          <rect
            id="checkbox"
            fill={props.primarycolor}
            x="0"
            y="0"
            width="20"
            height="20"
            rx="10"
          />
          <path
            id="Path-3"
            stroke="#FFFFFF"
            d="M6 10.3674974L8.82129486 13 14 7"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);

interface CheckboxUncheckProps extends React.SVGAttributes<SVGElement> {
  size?: string;
  primarycolor: string;
}
export const CheckboxUncheck: React.FunctionComponent<CheckboxUncheckProps> = ({
  size,
  ...props
}) => (
  <svg
    viewBox="0 0 20 20"
    fill={props.primarycolor}
    width={size || '20'}
    height={size || '20'}
    {...props}
  >
    <g
      id="SOCIAL-CHAT"
      stroke="none"
      fill="none"
      strokeWidth="1"
      fillRule="evenodd"
      strokeOpacity=".135"
    >
      <g
        id="ICONS"
        transform="translate(-192 -36)"
        stroke={props.primarycolor}
        strokeWidth="2"
      >
        <rect id="checkbox" x="193" y="37" width="18" height="18" rx="9" />
      </g>
    </g>
  </svg>
);
